import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  ResponseEmpListESSDto,
} from "../dto/request-for.dto";

@Injectable()
export class RequestForApi {

  private service: string = '';
  private model: string = 'requestfor';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public empListESS(limit: string | number, skip: string | number, search: string, module: string): Observable<ResponseEmpListESSDto> {
    const method: string = 'GET';
    const func: string = 'empListESS';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;
    if (typeof search !== 'undefined' && search !== null) urlParams.search = search;
    if (typeof module !== 'undefined' && module !== null) urlParams.module = module;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEmpListESSDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/request-for.api.ts